var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGroupNonSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.298,
    height: 24,
    viewBox: "0 0 24.298 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2,.prefix__cls-3{fill:none;stroke:#afafaf;stroke-linecap:round;stroke-width:2px}.prefix__cls-3{stroke-miterlimit:10}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon__Group_-_Non_Selected",
    "data-name": "Icon_ Group - Non Selected",
    transform: "translate(.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_-_Group_-_Selected",
    "data-name": "Icon - Group - Selected",
    transform: "translate(.727 6.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_5802",
    "data-name": "Group 5802",
    transform: "translate(.125 .063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_5799",
    "data-name": "Group 5799",
    transform: "translate(6.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_387",
    d: "M0 0L7.433 0",
    className: "prefix__cls-2",
    "data-name": "Line 387",
    transform: "translate(0 11.149)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_1074",
    cx: 3.097,
    cy: 3.097,
    r: 3.097,
    className: "prefix__cls-3",
    "data-name": "Ellipse 1074",
    transform: "translate(1.858)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8010",
    d: "M309.411 8126.824a4.955 4.955 0 1 1 9.91 0",
    className: "prefix__cls-3",
    "data-name": "Path 8010",
    transform: "translate(-309.411 -8115.675)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_5800",
    "data-name": "Group 5800",
    transform: "translate(16.894 3.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_389",
    d: "M0 0L4.026 0",
    className: "prefix__cls-2",
    "data-name": "Line 389",
    transform: "translate(1.378 7.482)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_1075",
    cx: 2.078,
    cy: 2.078,
    r: 2.078,
    className: "prefix__cls-3",
    "data-name": "Ellipse 1075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8011",
    d: "M326.687 8124.231a3.325 3.325 0 0 1 5.4 2.6",
    className: "prefix__cls-3",
    "data-name": "Path 8011",
    transform: "translate(-326.687 -8119.345)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_5801",
    "data-name": "Group 5801",
    transform: "translate(0 3.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_388",
    d: "M0 0L4.026 0",
    className: "prefix__cls-2",
    "data-name": "Line 388",
    transform: "translate(0 7.482)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_1076",
    cx: 2.078,
    cy: 2.078,
    r: 2.078,
    className: "prefix__cls-3",
    "data-name": "Ellipse 1076",
    transform: "translate(1.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8012",
    d: "M304.814 8124.231a3.325 3.325 0 0 0-5.4 2.6",
    className: "prefix__cls-3",
    "data-name": "Path 8012",
    transform: "translate(-299.411 -8119.345)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroupNonSelected);
export default __webpack_public_path__ + "static/media/icon-group-non-selected.e18a6787b21cebf12c2538390b84ddfd.svg";
export { ForwardRef as ReactComponent };